import { paths } from "../api-sdk/openapi-spec";
import { LOCAL_STORAGE_KEYS, BEAM_COOKIE_NAMES } from "../api-sdk/constants";
export type TPromoCodeRequest =
  paths["/productDetailsPage"]["post"]["requestBody"]["content"]["application/json"]["promos"];
export type TUnvalidatedPromoRequest = NonNullable<TPromoCodeRequest>["unvalidatedPromoCodes"];

export type TPromoCodeAttribute = { value: string; url?: never } | { url: string; value?: never };

export type TPromoCodeResponse =
  paths["/productDetailsPage"]["post"]["responses"]["200"]["content"]["application/json"]["promos"];
export type TValidatedPromoResponse = NonNullable<TPromoCodeResponse>["validatedPromoCodes"];

export enum PromoCodeSource {
  Manual = "manual",
  Url = "url",
}

type TManualPromoCode = {
  type: "manual";
  attributes: { value: string };
};

type TUrlPromoCode = {
  type: "url";
  attributes: { url: string };
};

export type TUnvalidatedPromoCode = TManualPromoCode | TUrlPromoCode;

export const PROMO_LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEYS.PROMO;
export const PROMO_CODES_COOKIE_NAME = BEAM_COOKIE_NAMES.PROMO_CODES;
